export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/60 text-primary-600 text-xs font-medium mb-4">
              编辑精选
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              精选推荐
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              编辑团队精心挑选的高分好剧，每一部都值得你花时间追完
            </p>
          </div>

          <div className="space-y-6 md:space-y-8">
            <div className="group flex flex-col lg:flex-row gap-6 md:gap-8 bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="lg:w-2/5 flex-shrink-0">
                <div className="relative h-52 md:h-64 lg:h-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20period%20drama%20scene%20with%20warm%20golden%20hour%20lighting%2C%20emotional%20characters%20in%20vintage%20costumes%2C%20cinematic%20composition%2C%20dramatic%20atmosphere%2C%20film%20grain%20texture%2C%20rich%20color%20grading&width=800&height=500&seq=carousel-item-01&orientation=landscape"
                    alt="繁华似锦"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent lg:bg-gradient-to-r"></div>
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    热播推荐
                  </span>
                </div>
              </div>
              <div className="flex-1 flex flex-col justify-center px-5 md:px-8 pb-6 md:pb-8 lg:py-8">
                <span className="text-xs font-medium text-primary-400 mb-2">年度现象级国产大剧</span>
                <h3 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3 group-hover:text-primary-400 transition-colors">繁华似锦</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">一部讲述改革开放背景下青年创业与情感故事的史诗级作品，全40集高清完整版已上线。真实还原时代变迁中的人性光辉，演技派阵容倾情演绎。</p>
                <div className="flex items-center gap-3">
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-400 cursor-pointer"><i className="ri-play-circle-line text-lg"></i>立即观看</span>
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500 cursor-pointer"><i className="ri-heart-line"></i>收藏</span>
                </div>
              </div>
            </div>

            <div className="group flex flex-col lg:flex-row-reverse gap-6 md:gap-8 bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="lg:w-2/5 flex-shrink-0">
                <div className="relative h-52 md:h-64 lg:h-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20scene%20with%20soft%20backlighting%2C%20young%20couple%20in%20urban%20setting%2C%20photography%20studio%20aesthetic%2C%20warm%20pastel%20tones%2C%20cinematic%20mood%2C%20dreamy%20atmosphere&width=800&height=500&seq=carousel-item-02&orientation=landscape"
                    alt="逆光之恋"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent lg:bg-gradient-to-l"></div>
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    热播韩剧
                  </span>
                </div>
              </div>
              <div className="flex-1 flex flex-col justify-center px-5 md:px-8 pb-6 md:pb-8 lg:py-8">
                <span className="text-xs font-medium text-accent-400 mb-2">2026暑期最甜韩剧</span>
                <h3 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3 group-hover:text-primary-400 transition-colors">逆光之恋</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">当红偶像主演的浪漫爱情喜剧，讲述摄影师与模特的意外邂逅。更新至16集，每周三四更新，甜蜜剧情引爆社交媒体热议。</p>
                <div className="flex items-center gap-3">
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-400 cursor-pointer"><i className="ri-play-circle-line text-lg"></i>立即观看</span>
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500 cursor-pointer"><i className="ri-heart-line"></i>收藏</span>
                </div>
              </div>
            </div>

            <div className="group flex flex-col lg:flex-row gap-6 md:gap-8 bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="lg:w-2/5 flex-shrink-0">
                <div className="relative h-52 md:h-64 lg:h-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20at%20night%20with%20lanterns%20and%20architecture%2C%20mysterious%20atmosphere%2C%20Tang%20Dynasty%20aesthetic%2C%20cinematic%20lighting%20with%20warm%20red%20tones%2C%20dramatic%20shadows%2C%20epic%20scale&width=800&height=500&seq=carousel-item-03&orientation=landscape"
                    alt="长安十二时辰"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent lg:bg-gradient-to-r"></div>
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-secondary-500 text-background-50 text-xs font-medium">
                    经典重映
                  </span>
                </div>
              </div>
              <div className="flex-1 flex flex-col justify-center px-5 md:px-8 pb-6 md:pb-8 lg:py-8">
                <span className="text-xs font-medium text-secondary-400 mb-2">4K修复版经典重映</span>
                <h3 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3 group-hover:text-primary-400 transition-colors">长安十二时辰</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">国产古装悬疑巅峰之作，4K高清修复版全新上线。跟随天才捕吏张小敬在十二时辰内破解惊天阴谋，每一帧都是视觉享受。</p>
                <div className="flex items-center gap-3">
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-400 cursor-pointer"><i className="ri-play-circle-line text-lg"></i>立即观看</span>
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500 cursor-pointer"><i className="ri-heart-line"></i>收藏</span>
                </div>
              </div>
            </div>

            <div className="group flex flex-col lg:flex-row-reverse gap-6 md:gap-8 bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="lg:w-2/5 flex-shrink-0">
                <div className="relative h-52 md:h-64 lg:h-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Dark%20moody%20courtroom%20and%20investigation%20scene%2C%20Korean%20thriller%20drama%20aesthetic%2C%20mysterious%20atmosphere%2C%20professional%20characters%20in%20shadow%2C%20cinematic%20noir%20style%2C%20deep%20contrast&width=800&height=500&seq=carousel-item-04&orientation=landscape"
                    alt="秘密森林第三季"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent lg:bg-gradient-to-l"></div>
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    高分必看
                  </span>
                </div>
              </div>
              <div className="flex-1 flex flex-col justify-center px-5 md:px-8 pb-6 md:pb-8 lg:py-8">
                <span className="text-xs font-medium text-accent-400 mb-2">豆瓣9.4分神作回归</span>
                <h3 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3 group-hover:text-primary-400 transition-colors">秘密森林第三季</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">韩国现象级悬疑律政剧第三季，黄始木与韩汝真的故事继续。全16集已完结，错综复杂的案件背后，是对正义与权力的深刻拷问。</p>
                <div className="flex items-center gap-3">
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-400 cursor-pointer"><i className="ri-play-circle-line text-lg"></i>立即观看</span>
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500 cursor-pointer"><i className="ri-heart-line"></i>收藏</span>
                </div>
              </div>
            </div>

            <div className="group flex flex-col lg:flex-row gap-6 md:gap-8 bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 overflow-hidden transition-all duration-300 cursor-pointer">
              <div className="lg:w-2/5 flex-shrink-0">
                <div className="relative h-52 md:h-64 lg:h-full">
                  <img
                    src="https://readdy.ai/api/search-image?query=Rural%20Chinese%20landscape%20with%20golden%20sunset%20lighting%2C%20vast%20yellow%20earth%20plateau%2C%20simple%20village%20life%2C%20documentary%20style%20realism%2C%20warm%20earthy%20tones%2C%20emotional%20depth&width=800&height=500&seq=carousel-item-05&orientation=landscape"
                    alt="山海情"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-50/70 via-transparent to-transparent lg:bg-gradient-to-r"></div>
                  <span className="absolute top-4 left-4 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    口碑佳作
                  </span>
                </div>
              </div>
              <div className="flex-1 flex flex-col justify-center px-5 md:px-8 pb-6 md:pb-8 lg:py-8">
                <span className="text-xs font-medium text-primary-400 mb-2">现实主义口碑力作</span>
                <h3 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-3 group-hover:text-primary-400 transition-colors">山海情</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">以真实扶贫故事为蓝本，讲述西北农村人民艰苦奋斗的时代画卷。全23集，朴实无华的叙事却有着震撼人心的力量，值得反复回味。</p>
                <div className="flex items-center gap-3">
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-400 cursor-pointer"><i className="ri-play-circle-line text-lg"></i>立即观看</span>
                  <span className="inline-flex items-center gap-1.5 text-sm text-foreground-500 cursor-pointer"><i className="ri-heart-line"></i>收藏</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}